import {
    EDUCATOR_PAGE_GET_REQUEST,
    EDUCATOR_PAGE_GET_SUCCESS,
    EDUCATOR_CACHED_EDUCATOR_DATA_USED,
    EDUCATOR_PAGE_GET_FAILURE,
} from './types';
import { history, toaster, request, sendSlackMessage } from 'cademy-shared-web';

// const getMembershipsForEducator = (educatorRef) => {

//     return request.get(`/get-data/memberships?educator_ref=${educatorRef}`)
//         .then(({data}) => {
//             return data.data;
//         });
// }

export const getEducatorPageData =
    (educatorSlug, isMarketplace = false) =>
    async (dispatch, getState) => {
        if (!educatorSlug) {
            return { type: EDUCATOR_PAGE_GET_FAILURE };
        }

        const cachedEducatorSlug = getState().educator.currentEducator.slug;
        if (cachedEducatorSlug === educatorSlug) {
            return { type: EDUCATOR_CACHED_EDUCATOR_DATA_USED };
        }

        dispatch({ type: EDUCATOR_PAGE_GET_REQUEST });

        let res;
        try {
            res = await request.get(
                `/get-educator-data/${educatorSlug}?is_marketplace=${isMarketplace}`
            );
        } catch (err) {
            const message = `We can't find a page matching: ${educatorSlug}`;
            toaster.warning(message, undefined, { dontSlack: true });
            sendSlackMessage(
                'Educator not found error',
                ':red_circle: ',
                `Couldn't getEducatorPageData... \n*Safe:* \`\`\`${err.safe}\`\`\` \n*Error code:* ${err.errorCode} \n*Location:* ${window.location.href} \n*User Agent:* ${navigator.userAgent}`,
                undefined,
                err
            );
            history.push('/');
            dispatch({ type: EDUCATOR_PAGE_GET_FAILURE, payload: message });
            throw err;
        }
        const { data } = res;

        dispatch({
            type: EDUCATOR_PAGE_GET_SUCCESS,
            payload: { currentEducator: { ...data.educator, ...data } },
        });

        return data;
    };

export const getEducator = (educatorSlug = '') => {
    return request
        .get(`/get-data/educators?slug=${educatorSlug}`)
        .then(({ data }) => {
            if (data && data.data && data.data[0]) {
                return data.data[0];
            }
        })
        .catch(() => {});
};
